import React from "react";
import { FormSection, InputField } from "../../../common/FormComponents";

type ContactInfo = {
  firstName: string;
  lastName: string;
  title: string;
  phone: string;
  mobilePhone: string;
  email: string;
};

type ContactInfoSectionProps = {
  contactInfo: ContactInfo;
  onChange: ({
    field,
    value,
  }: {
    field: keyof ContactInfo;
    value: string;
  }) => void;
  errors?: Record<string, string>;
};

const ContactInfoSection = ({
  contactInfo,
  onChange,
  errors = {},
}: ContactInfoSectionProps) => {
  const handleChange =
    (field: keyof ContactInfo) => (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ field, value: e.target.value });
    };

  return (
    <FormSection
      title="Primary Contact Information (Voting Member)"
      tooltipText="Enter the primary contact person's information"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6">
        <InputField
          id="first-name"
          name="firstName"
          label="First Name"
          value={contactInfo.firstName}
          onChange={handleChange("firstName")}
          error={!!errors.firstName}
          helperText={errors.firstName || ""}
          required
          tooltipText="Enter the contact person's first name"
        />

        <InputField
          id="last-name"
          name="lastName"
          label="Last Name"
          value={contactInfo.lastName}
          onChange={handleChange("lastName")}
          error={!!errors.lastName}
          helperText={errors.lastName || ""}
          required
          tooltipText="Enter the contact person's last name"
        />

        <InputField
          id="title"
          name="title"
          label="Job Title"
          value={contactInfo.title}
          onChange={handleChange("title")}
          error={!!errors.title}
          helperText={errors.title || ""}
          tooltipText="Enter the contact person's job title or position"
        />

        <InputField
          id="email"
          name="email"
          label="Email"
          value={contactInfo.email}
          onChange={handleChange("email")}
          error={!!errors.email}
          helperText={errors.email || ""}
          required
          tooltipText="Enter the contact person's email address"
        />

        <InputField
          id="phone"
          name="phone"
          label="Company Phone"
          value={contactInfo.phone}
          onChange={handleChange("phone")}
          error={!!errors.phone}
          helperText={errors.phone || ""}
          tooltipText="Enter the contact person's office or work phone number"
        />

        <InputField
          id="mobile-phone"
          name="mobilePhone"
          label="Mobile Phone"
          value={contactInfo.mobilePhone}
          onChange={handleChange("mobilePhone")}
          error={!!errors.mobilePhone}
          helperText={errors.mobilePhone || ""}
          tooltipText="Enter the contact person's mobile phone number"
        />
      </div>
    </FormSection>
  );
};

export default ContactInfoSection;
